import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-check
import { ActivityBlock } from '../../../abstract/ActivityBlock.js';
import { SolutionBlock } from '../../../abstract/SolutionBlock.js';
export class FileUploaderInline extends SolutionBlock {
  constructor() {
    super();
    this.init$ = _objectSpread(_objectSpread({}, this.init$), {}, {
      couldCancel: false,
      cancel: () => {
        if (this.couldHistoryBack) {
          this.$['*historyBack']();
        } else if (this.couldShowList) {
          this.$['*currentActivity'] = ActivityBlock.activities.UPLOAD_LIST;
        }
      }
    });
  }
  get couldHistoryBack() {
    const history = this.$['*history'];
    return history.length > 1 && history[history.length - 1] !== ActivityBlock.activities.START_FROM;
  }
  get couldShowList() {
    return this.cfg.showEmptyList || this.$['*uploadList'].length > 0;
  }
  shadowReadyCallback() {
    /** @type {import('../../../abstract/UploaderBlock.js').UploaderBlock} */
    const uBlock = this.ref.uBlock;
    this.sub('*currentActivity', val => {
      if (!val) {
        this.$['*currentActivity'] = uBlock.initActivity || ActivityBlock.activities.START_FROM;
      }
    });
    this.sub('*uploadList', list => {
      if ((list === null || list === void 0 ? void 0 : list.length) > 0 && this.$['*currentActivity'] === (uBlock.initActivity || ActivityBlock.activities.START_FROM)) {
        this.$['*currentActivity'] = ActivityBlock.activities.UPLOAD_LIST;
      }
    });
    this.sub('*history', () => {
      this.$['couldCancel'] = this.couldHistoryBack || this.couldShowList;
    });
  }
}
FileUploaderInline.template = /* HTML */" <lr-start-from>\n    <lr-drop-area with-icon clickable></lr-drop-area>\n    <lr-source-list wrap></lr-source-list>\n    <button\n      type=\"button\"\n      l10n=\"start-from-cancel\"\n      class=\"cancel-btn secondary-btn\"\n      set=\"onclick: cancel; @hidden: !couldCancel\"\n    ></button>\n    <lr-copyright></lr-copyright>\n  </lr-start-from>\n  <lr-upload-list ref=\"uBlock\"></lr-upload-list>\n  <lr-camera-source></lr-camera-source>\n  <lr-url-source></lr-url-source>\n  <lr-external-source></lr-external-source>\n  <lr-progress-bar></lr-progress-bar>\n  <lr-cloud-image-editor-activity></lr-cloud-image-editor-activity>";